import { ModalState } from './globalModal';
import { genericAtom } from '../jotai';

const subModalStateDefault: ModalState = {
    isOpen: false,
    titleTransCode: undefined,
    content: null,
    footer: null,
    okText: undefined,
    showModalDelete: false,
    showModalConfirm: false,
    showModalFinish: false,
    closeIcon: undefined,
    title: null,
    showDivider: true,
    maskClosable: false,
};

export const subModalState = genericAtom<ModalState | null>(subModalStateDefault);
